export interface StoredPaymentMethod {
  id: string;
  card_mask: string;
  card_expiry: string;
  card_type: string;
  requires_authentication?: boolean;
}

// Legacy saved-card model, identified by a non-spm_ id; superseded by the spm_-prefixed StoredPaymentMethod.
export function isPaymentInstrument(spm: StoredPaymentMethod): boolean {
  return !spm.id.startsWith("spm_");
}

export function isAuthenticated(spm: StoredPaymentMethod): boolean {
  return !spm.requires_authentication;
}
